import classnames from 'classnames';

import type { EmbeddedVideoProps } from './types';

import useStyles from './styles';
import testIds from './testIds';

import YoutubeVideo from './YoutubeVideo';

const EmbeddedVideo = (props: EmbeddedVideoProps) => {
  const { videoLink, className } = props;
  const styles = useStyles();
  let Component = null;

  if (videoLink.includes('youtube')) {
    Component = YoutubeVideo;
  }

  return (
    <div className={classnames(styles.root, className)} data-testid={testIds.root}>
      {Component && <Component {...props} />}
    </div>
  );
};

export default EmbeddedVideo;
